import { configureStore } from '@reduxjs/toolkit';

import configuratorSlice from './configurator-slice';
import addressBookSlice from './address-book-slice';

const store = configureStore({
  reducer: { 
    configurator: configuratorSlice.reducer, 
    addressBook: addressBookSlice.reducer 
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  })
});

export default store;